import BigNumber from 'bignumber.js'
import { useCallback } from 'react'
import { mintGLITCH } from 'utils/calls'
import { useContractGLITCH } from 'hooks/useContract'
import { TransactionResponse } from '@ethersproject/providers'
import { TransactionReceipt } from '@ethersproject/abstract-provider/src.ts/index'

const useMintGLITCH = (
  price: string,
  amount: string,
  walletAddress: string
) => {
  const glitchContract = useContractGLITCH()

  const handleMint = useCallback(
    async (
      onTransactionSubmitted: (tx: TransactionResponse) => void,
      onSuccess: (receipt: TransactionReceipt) => void,
      onError: (receipt: TransactionReceipt) => void,
    ) => {
      const tx = await mintGLITCH(
        glitchContract,
        walletAddress,
        price,
        amount
      )
      onTransactionSubmitted(tx)
      const receipt = await tx.wait()
      if (receipt.status) {
        onSuccess(receipt)
      } else {
        onError(receipt)
      }
    },
    [amount, glitchContract],
  )

  return { onMint: handleMint }
}

export default useMintGLITCH
